export default __webpack_public_path__ + "static/media/intro-screen.b2497bb.mp4";